interface DefaultErrorFallbackProps {
  error: Error | null;
  onRetry: () => void;
}

export function DefaultErrorFallback({ error, onRetry }: DefaultErrorFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center p-4 sm:p-6 text-center rounded-lg border border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-950">
      <h3 className="text-base sm:text-lg font-semibold text-red-600 dark:text-red-400 mb-2">
        Something went wrong
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        {error?.message || 'An unexpected error occurred'}
      </p>
      <button
        onClick={onRetry}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors min-h-[44px] min-w-[44px]"
      >
        Try Again
      </button>
    </div>
  );
}

export type { DefaultErrorFallbackProps };
